// @flow

import styled from 'styled-components';
import type { Theme } from '../../../../types';

type Props = {
  boxed: boolean,
};

export default styled<any, Theme, Props>('div')`
  display: flex;
  align-items: center;
  font-size: 10px;
  padding: 1em;
  color: ${props => (props.boxed ? props.theme.gallery.boxedDescriptionColor : props.theme.gallery.descriptionColor)};
`;
